// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-section {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: #982D67;
  color: #FFFFFF;
  transform: none !important;
  z-index: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.about-section.visible {
  z-index: 1;
}
.about-section .about-section-container {
  width: calc(100% - 160px);
  height: calc(100% - 160px);
  transform: none !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 1620px) {
  .about-section .about-section-container {
    width: calc(100% - 200px);
    height: calc(100% - 240px);
  }
}
@media (max-width: 1050px) {
  .about-section .about-section-container {
    width: calc(100% - 80px);
    height: calc(100% - 240px);
  }
}
@media (max-width: 550px) {
  .about-section .about-section-container {
    width: calc(100% - 32px);
    height: calc(100% - 128px);
  }
}
.about-section .about-section-container .about-section-text-block {
  width: 100%;
  position: relative;
}
@media (max-width: 800px) {
  .about-section .about-section-container .about-section-text-block {
    order: 2;
  }
}
.about-section .about-section-container .about-section-text-block .about-section-text-block-number {
  width: 35px;
  height: 25px;
  padding-top: 4px;
  opacity: 0.6;
  border-radius: 24px;
  border: 2px solid #FFFFFF;
  position: absolute;
  top: 5px;
  left: 0;
  font-family: FixelDisplay;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1620px) {
  .about-section .about-section-container .about-section-text-block .about-section-text-block-number {
    width: 48px;
    height: 35px;
    font-family: FixelDisplay;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
@media (max-width: 800px) {
  .about-section .about-section-container .about-section-text-block .about-section-text-block-number {
    width: 35px;
    height: 18px;
    margin-top: -5px;
    font-family: FixelText;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
}
@media (max-width: 550px) {
  .about-section .about-section-container .about-section-text-block .about-section-text-block-number {
    width: 21px;
    height: 11px;
    margin-top: -7px;
    border: 1px solid #FFFFFF;
    font-family: FixelText;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
}
.about-section .about-section-container .about-section-text-block .about-section-text-block-chars {
  width: 100%;
  height: 260px;
  position: relative;
  font-family: FixelText;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
@media (min-width: 1620px) {
  .about-section .about-section-container .about-section-text-block .about-section-text-block-chars {
    font-family: FixelText;
    font-size: 50px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
}
@media (max-width: 800px) {
  .about-section .about-section-container .about-section-text-block .about-section-text-block-chars {
    height: 180px;
    font-family: FixelText;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
}
@media (max-width: 550px) {
  .about-section .about-section-container .about-section-text-block .about-section-text-block-chars {
    height: 118px;
    font-family: FixelText;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
}
.about-section .about-section-container .about-section-text-block .about-section-text-block-chars .about-section-text-block-chars-box {
  position: absolute;
  left: 0;
  top: 0;
}
.about-section .about-section-container .about-section-text-block .about-section-text-block-chars .about-section-text-block-chars-box .about-section-text-block-chars-space {
  opacity: 0;
}
.about-section .about-section-container .about-section-text-block .about-section-text-block-chars .about-section-text-block-chars-box .about-section-main-text {
  color: rgba(255, 255, 255, 0.5);
}
.about-section .about-section-container .about-section-text-block .about-section-text-block-chars .about-section-text-block-chars-box .about-section-main-text .char {
  opacity: 0;
}
.about-section .about-section-container .about-section-title-block {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
@media (max-width: 800px) {
  .about-section .about-section-container .about-section-title-block {
    gap: 48px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
}
.about-section .about-section-container .about-section-title-block .about-section-title-block-points-box {
  width: 300px;
  height: 61px;
  letter-spacing: 0.14px;
  text-transform: uppercase;
  position: relative;
  gap: 8px;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .about-section .about-section-container .about-section-title-block .about-section-title-block-points-box {
    width: 350px;
    height: 70px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 800px) {
  .about-section .about-section-container .about-section-title-block .about-section-title-block-points-box {
    order: 2;
  }
}
@media (max-width: 550px) {
  .about-section .about-section-container .about-section-title-block .about-section-title-block-points-box {
    width: 100%;
    gap: 4px;
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
.about-section .about-section-container .about-section-title-block .about-section-title-block-points-box .about-section-title-block-point {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.about-section .about-section-container .about-section-title-block .about-section-title-block-points-box .about-section-title-block-point .point-item {
  gap: 6px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.about-section .about-section-container .about-section-title-block .about-section-title-block-points-box .about-section-title-block-point .point-item div .char {
  opacity: 0;
  display: inline-block;
}
.about-section .about-section-container .about-section-title-block .about-section-title {
  gap: 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}
@media (min-width: 1620px) {
  .about-section .about-section-container .about-section-title-block .about-section-title {
    gap: 48px;
  }
}
@media (max-width: 800px) {
  .about-section .about-section-container .about-section-title-block .about-section-title {
    gap: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-sb {
  opacity: 0.5;
  letter-spacing: 0.14px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-sb {
    letter-spacing: 0.16px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-sb {
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
.about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text {
  letter-spacing: -4.96px;
  margin-bottom: -15px;
  text-transform: uppercase;
  position: relative;
  font-family: FixelDisplay;
  font-size: 124px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
}
@media (min-width: 1620px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text {
    letter-spacing: -6.4px;
    font-family: FixelDisplay;
    font-size: 160px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 1250px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text {
    font-family: FixelDisplay;
    font-size: 80px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 1050px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text {
    font-family: FixelDisplay;
    font-size: 64px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 550px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text {
    letter-spacing: -1.38px;
    font-family: FixelDisplay;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
.about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .top-text,
.about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .bottom-text {
  min-width: 900px;
  text-align: end;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
}
@media (min-width: 1620px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .top-text,
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .bottom-text {
    min-width: 1200px;
  }
}
@media (max-width: 1250px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .top-text,
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .bottom-text {
    min-width: 600px;
  }
}
@media (max-width: 1050px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .top-text,
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .bottom-text {
    min-width: 470px;
  }
}
@media (max-width: 800px) {
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .top-text,
  .about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .bottom-text {
    text-align: start;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .top-text .char,
.about-section .about-section-container .about-section-title-block .about-section-title .about-section-title-text .bottom-text .char {
  opacity: 0;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/AboutSection/AboutSection.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,yBCPS;EDQT,cCPI;EDSJ,0BAAA;EACA,UAAA;EEZA,aAAA;EACA,mBFYqB;EEXrB,uBFW0B;EEV1B,mBFUkC;AAAtC;AAEI;EACI,UAAA;AAAR;AAGI;EACI,yBAAA;EACA,0BAAA;EACA,0BAAA;EEtBJ,aAAA;EACA,sBFsByB;EErBzB,8BFqBiC;EEpBjC,mBFoBgD;AAEpD;AAAQ;EANJ;IAOQ,yBAAA;IACA,0BAAA;EAGV;AACF;AADQ;EAXJ;IAYQ,wBAAA;IACA,0BAAA;EAIV;AACF;AAFQ;EAhBJ;IAiBQ,wBAAA;IACA,0BAAA;EAKV;AACF;AAHQ;EACI,WAAA;EACA,kBAAA;AAKZ;AAHY;EAJJ;IAKQ,QAAA;EAMd;AACF;AAJY;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EElDZ,yBFmDiC;EElDjC,eFkD+C;EEjD/C,kBFiDqD;EEhDrD,gBFgD6D;EE/C7D,iBF+CkE;EE1DlE,aAAA;EACA,mBF0DiC;EEzDjC,uBFyDsC;EExDtC,mBFwD8C;AAalD;AAXgB;EAbJ;IAcQ,WAAA;IACA,YAAA;IExDhB,yBFyDqC;IExDrC,eFwDmD;IEvDnD,kBFuDyD;IEtDzD,gBFsDiE;IErDjE,iBFqDsE;EAkBxE;AACF;AAhBgB;EAnBJ;IAoBQ,WAAA;IACA,YAAA;IACA,gBAAA;IE/DhB,sBFgEqC;IE/DrC,eF+DgD;IE9DhD,kBF8DsD;IE7DtD,gBF6D8D;IE5D9D,iBF4DmE;EAuBrE;AACF;AArBgB;EA1BJ;IA2BQ,WAAA;IACA,YAAA;IACA,gBAAA;IACA,yBAAA;IEvEhB,sBFwEqC;IEvErC,eFuEgD;IEtEhD,kBFsEsD;IErEtD,gBFqE8D;IEpE9D,iBFoEmE;EA4BrE;AACF;AAzBY;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EE/EZ,sBFgFiC;EE/EjC,eF+E4C;EE9E5C,kBF8EkD;EE7ElD,gBF6E0D;EE5E1D,iBF4E+D;AA+BnE;AA7BgB;EANJ;IE5ER,sBFmFqC;IElFrC,eFkFgD;IEjFhD,kBFiFsD;IEhFtD,gBFgF8D;IE/E9D,iBF+EmE;EAoCrE;AACF;AAlCgB;EAVJ;IAWQ,aAAA;IEvFhB,sBFwFqC;IEvFrC,eFuFgD;IEtFhD,kBFsFsD;IErFtD,gBFqF8D;IEpF9D,iBFoFmE;EAyCrE;AACF;AAvCgB;EAfJ;IAgBQ,aAAA;IE5FhB,sBF6FqC;IE5FrC,eF4FgD;IE3FhD,kBF2FsD;IE1FtD,gBF0F8D;IEzF9D,iBFyFmE;EA8CrE;AACF;AA5CgB;EACI,kBAAA;EACA,OAAA;EACA,MAAA;AA8CpB;AA5CoB;EACI,UAAA;AA8CxB;AA3CoB;EACI,+BCtGT;ADmJf;AA3CwB;EACI,UAAA;AA6C5B;AAtCQ;EACI,WAAA;EE5HR,aAAA;EACA,mBF4H6B;EE3H7B,8BF2HkC;EE1HlC,qBF0HiD;AA2CrD;AAzCY;EAJJ;IAKQ,SAAA;IEhIZ,aAAA;IACA,sBFgIiC;IE/HjC,8BF+HyC;IE9HzC,uBF8HwD;EA+C1D;AACF;AA7CY;EACI,YAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EEnIZ,yBFoIiC;EEnIjC,eFmI+C;EElI/C,kBFkIqD;EEjIrD,gBFiI6D;EEhI7D,iBFgIkE;AAmDtE;AAjDgB;EATJ;IAUQ,YAAA;IACA,YAAA;IExIhB,yBFyIqC;IExIrC,eFwImD;IEvInD,kBFuIyD;IEtIzD,gBFsIiE;IErIjE,iBFqIsE;EAwDxE;AACF;AAtDgB;EAfJ;IAgBQ,QAAA;EAyDlB;AACF;AAvDgB;EAnBJ;IAoBQ,WAAA;IACA,QAAA;IElJhB,yBFmJqC;IElJrC,eFkJmD;IEjJnD,kBFiJyD;IEhJzD,gBFgJiE;IE/IjE,iBF+IsE;EA8DxE;AACF;AA5DgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EEnKhB,aAAA;EACA,sBFmKqC;EElKrC,2BFkK6C;EEjK7C,uBFiKyD;AAiE7D;AA/DoB;EACI,QAAA;EEvKpB,aAAA;EACA,mBFuKyC;EEtKzC,2BFsK8C;EErK9C,uBFqK0D;AAoE9D;AAjE4B;EACI,UAAA;EACA,qBAAA;AAmEhC;AA5DY;EACI,SAAA;EErLZ,aAAA;EACA,sBFqLiC;EEpLjC,yBFoLyC;EEnLzC,qBFmLmD;AAiEvD;AA/DgB;EAJJ;IAKQ,SAAA;EAkElB;AACF;AAhEgB;EARJ;IASQ,SAAA;IE7LhB,aAAA;IACA,sBF6LqC;IE5LrC,2BF4L6C;IE3L7C,uBF2LyD;EAsE3D;AACF;AApEgB;EACI,YAAA;EACA,sBAAA;EACA,yBAAA;EE7LhB,yBF8LqC;EE7LrC,eF6LmD;EE5LnD,kBF4LyD;EE3LzD,gBF2LiE;EE1LjE,iBF0LsE;AA0E1E;AAxEoB;EANJ;IAOQ,sBAAA;IEjMpB,yBFkMyC;IEjMzC,eFiMuD;IEhMvD,kBFgM6D;IE/L7D,gBF+LqE;IE9LrE,iBF8L0E;EA+E5E;AACF;AA7EoB;EAXJ;IE1LZ,yBFsMyC;IErMzC,eFqMuD;IEpMvD,kBFoM6D;IEnM7D,gBFmMqE;IElMrE,iBFkM0E;EAoF5E;AACF;AAjFgB;EACI,uBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EE9MhB,yBF+MqC;EE9MrC,gBF8MmD;EE7MnD,kBF6M0D;EE5M1D,gBF4MkE;EE3MlE,gBF2MuE;AAuF3E;AArFoB;EAPJ;IAQQ,sBAAA;IElNpB,yBFmNyC;IElNzC,gBFkNuD;IEjNvD,kBFiN8D;IEhN9D,gBFgNsE;IE/MtE,gBF+M2E;EA4F7E;AACF;AA1FoB;EAZJ;IE1MZ,yBFuNyC;IEtNzC,eFsNuD;IErNvD,kBFqN6D;IEpN7D,gBFoNqE;IEnNrE,gBFmN0E;EAiG5E;AACF;AA/FoB;EAhBJ;IE1MZ,yBF2NyC;IE1NzC,eF0NuD;IEzNvD,kBFyN6D;IExN7D,gBFwNqE;IEvNrE,gBFuN0E;EAsG5E;AACF;AApGoB;EApBJ;IAqBQ,uBAAA;IE/NpB,yBFgOyC;IE/NzC,eF+NuD;IE9NvD,kBF8N6D;IE7N7D,gBF6NqE;IE5NrE,gBF4N0E;EA2G5E;AACF;AAzGoB;;EAEI,gBAAA;EACA,eAAA;EE7OpB,aAAA;EACA,mBF6OyC;EE5OzC,yBF4O8C;EE3O9C,qBF2OwD;AA8G5D;AA5GwB;EANJ;;IAOQ,iBAAA;EAgH1B;AACF;AA9GwB;EAVJ;;IAWQ,gBAAA;EAkH1B;AACF;AAhHwB;EAdJ;;IAeQ,gBAAA;EAoH1B;AACF;AAlHwB;EAlBJ;;IAmBQ,iBAAA;IE7PxB,aAAA;IACA,mBF6P6C;IE5P7C,2BF4PkD;IE3PlD,uBF2P8D;EAyHhE;AACF;AAvHwB;;EACI,UAAA;EACA,qBAAA;AA0H5B","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n.about-section {\n    width: 100%;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    background-color: $main-color;\n    color: $white;\n    // margin-bottom: 100vh;\n    transform: none !important;\n    z-index: 0;\n    @include mixins.flex(row, center, center);\n\n    &.visible {\n        z-index: 1;\n    }\n\n    .about-section-container {\n        width: calc(100% - 160px);\n        height: calc(100% - 160px);\n        transform: none !important;\n        @include mixins.flex(column, space-between, center);\n\n        @media (min-width: 1620px) {\n            width: calc(100% - 200px);\n            height: calc(100% - 240px);\n        }\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 80px);\n            height: calc(100% - 240px);\n        }\n\n        @media (max-width: 550px) {\n            width: calc(100% - 32px);\n            height: calc(100% - 128px);\n        }\n\n        .about-section-text-block {\n            width: 100%;\n            position: relative;\n\n            @media (max-width: 800px) {\n                order: 2;\n            }\n\n            .about-section-text-block-number {\n                width: 35px;\n                height: 25px;\n                padding-top: 4px;\n                opacity: 0.6;\n                border-radius: 24px;\n                border: 2px solid $white;\n                position: absolute;\n                top: 5px;\n                left: 0;\n                @include mixins.font(FixelDisplay, 18px, normal, 500, 100%);\n                @include mixins.flex(row, center, center);\n\n                @media (min-width: 1620px) {\n                    width: 48px;\n                    height: 35px;\n                    @include mixins.font(FixelDisplay, 32px, normal, 500, 130%);\n                }\n\n                @media (max-width: 800px) {\n                    width: 35px;\n                    height: 18px;\n                    margin-top: -5px;\n                    @include mixins.font(FixelText, 20px, normal, 400, 120%);\n                }\n\n                @media (max-width: 550px) {\n                    width: 21px;\n                    height: 11px;\n                    margin-top: -7px;\n                    border: 1px solid $white;\n                    @include mixins.font(FixelText, 10px, normal, 400, 120%);\n                }\n            }\n\n            .about-section-text-block-chars {\n                width: 100%;\n                height: 260px;\n                position: relative;\n                @include mixins.font(FixelText, 40px, normal, 400, 120%);\n\n                @media (min-width: 1620px) {\n                    @include mixins.font(FixelText, 50px, normal, 400, 120%);\n                }\n\n                @media (max-width: 800px) {\n                    height: 180px;\n                    @include mixins.font(FixelText, 24px, normal, 400, 120%);\n                }\n\n                @media (max-width: 550px) {\n                    height: 118px;\n                    @include mixins.font(FixelText, 14px, normal, 400, 120%);\n                }\n\n                .about-section-text-block-chars-box {\n                    position: absolute;\n                    left: 0;\n                    top: 0;\n\n                    .about-section-text-block-chars-space {\n                        opacity: 0;\n                    }\n    \n                    .about-section-main-text {\n                        color: $opacity-text;\n    \n                        .char {\n                            opacity: 0;\n                        }\n                    }\n                }\n            }\n        }\n\n        .about-section-title-block {\n            width: 100%;\n            @include mixins.flex(row, space-between, flex-end);\n\n            @media (max-width: 800px) {\n                gap: 48px;\n                @include mixins.flex(column, space-between, flex-start);\n            }\n\n            .about-section-title-block-points-box {\n                width: 300px;\n                height: 61px;\n                letter-spacing: 0.14px;\n                text-transform: uppercase;\n                position: relative;\n                gap: 8px;\n                @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                @media (min-width: 1620px) {\n                    width: 350px;\n                    height: 70px;\n                    @include mixins.font(FixelDisplay, 16px, normal, 500, 110%);\n                }\n\n                @media (max-width: 800px) {\n                    order: 2;\n                }\n\n                @media (max-width: 550px) {\n                    width: 100%;\n                    gap: 4px;\n                    @include mixins.font(FixelDisplay, 14px, normal, 500, 130%);\n                }\n\n                .about-section-title-block-point {\n                    width: 100%;\n                    height: 100%;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    gap: 8px;\n                    @include mixins.flex(column, flex-start, flex-start);\n\n                    .point-item {\n                        gap: 6px;\n                        @include mixins.flex(row, flex-start, flex-start);\n\n                        div {\n                            .char {\n                                opacity: 0;\n                                display: inline-block;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .about-section-title {\n                gap: 32px;\n                @include mixins.flex(column, flex-end, flex-end);\n\n                @media (min-width: 1620px) {\n                    gap: 48px;\n                }\n\n                @media (max-width: 800px) {\n                    gap: 16px;\n                    @include mixins.flex(column, flex-start, flex-start);\n                }\n\n                .about-section-title-sb {\n                    opacity: 0.5;\n                    letter-spacing: 0.14px;\n                    text-transform: uppercase;\n                    @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                    @media (min-width: 1620px) {\n                        letter-spacing: 0.16px;\n                        @include mixins.font(FixelDisplay, 16px, normal, 500, 110%);\n                    }\n\n                    @media (max-width: 550px) {\n                        @include mixins.font(FixelDisplay, 14px, normal, 500, 130%);\n                    }\n                }\n\n                .about-section-title-text {\n                    letter-spacing: -4.96px;\n                    margin-bottom: -15px;\n                    text-transform: uppercase;\n                    position: relative;\n                    @include mixins.font(FixelDisplay, 124px, normal, 400, 90%);\n\n                    @media (min-width: 1620px) {\n                        letter-spacing: -6.4px;\n                        @include mixins.font(FixelDisplay, 160px, normal, 400, 90%);\n                    }\n\n                    @media (max-width: 1250px) {\n                        @include mixins.font(FixelDisplay, 80px, normal, 400, 90%);\n                    }\n\n                    @media (max-width: 1050px) {\n                        @include mixins.font(FixelDisplay, 64px, normal, 400, 90%);\n                    }\n\n                    @media (max-width: 550px) {\n                        letter-spacing: -1.38px;\n                        @include mixins.font(FixelDisplay, 46px, normal, 400, 90%);\n                    }\n\n                    .top-text,\n                    .bottom-text {\n                        min-width: 900px;\n                        text-align: end;\n                        @include mixins.flex(row, flex-end, flex-end);\n\n                        @media (min-width: 1620px) {\n                            min-width: 1200px;\n                        }\n\n                        @media (max-width: 1250px) {\n                            min-width: 600px;\n                        }\n\n                        @media (max-width: 1050px) {\n                            min-width: 470px;\n                        }\n\n                        @media (max-width: 800px) {\n                            text-align: start;\n                            @include mixins.flex(row, flex-start, flex-start);\n                        }\n\n                        .char {\n                            opacity: 0;\n                            display: inline-block;\n                        }\n\n                        \n                    }\n                }\n            }\n        }\n    }\n}","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
